import { convertToMexicoTime } from 'utils/helpers/convertToMexicoTime';

// Función para obtener detalles de la transacción
export const getDetailsTransaction = (orderDetails) => {
  // Si recibimos un array, tomamos el primer elemento
  const detailsObj = Array.isArray(orderDetails) ? orderDetails[0] : orderDetails;
  if (!detailsObj) return [];
  return [
    {
      label: 'ID',
      value: detailsObj?.id,
    },
    {
      label: 'Compañía',
      value: detailsObj?.carrier_name,
    },
    {
      label: 'Fecha de transacción',
      value: convertToMexicoTime(detailsObj?.created),
    },
    {
      label: 'Número telefónico',
      value: detailsObj?.direct_number,
    },
    {
      label: 'ICCID',
      value: detailsObj?.icc_number,
    },
    {
      label: 'Tipo de SIM',
      value: detailsObj?.sim_type,
    },
  ];
};

// Función para obtener detalles de Error
export const getDateDetailsError = (orderDetails) => {
  const detailsObj = Array.isArray(orderDetails) ? orderDetails[0] : orderDetails;
  if (!detailsObj) return [];
  return [
    {
      label: 'Código de error',
      value: detailsObj?.error_code,
    },
    {
      label: 'Mensaje de error',
      value: detailsObj?.error_message,
    },
  ];
};
